import api from './client';

export const examinationsService = {
    addExaminations: async (credentials) => {
        const response = await api.post('examination', credentials);
        return response.data;
    },
    getAllExaminations: async () => {
        const response = await api.get('examination');
        return response.data;
    },
    updateExaminations: async (id, credentials) => {
        const response = await api.put(`examination/${id}`, credentials);
        return response.data;
    },
    deleteExaminations: async (id) => {
        const response = await api.delete(`examination/${id}`);
        return response.data;
    },
};